import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { MotionPlugin } from '@vueuse/motion';
import App from './App.vue';
import router from './router';
import { useAuthStore } from '@/features/auth/stores/auth';
import { installUnsavedDialogBeforeUnloadGuard } from './lib/unsaved-dialog-guard';
import { i18n } from './i18n';
import { initTheme } from '@/theme';
import './style.css';
import '@/features/auth/styles/finance-auth.css';

initTheme();

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(router);
app.use(i18n);
void useAuthStore(pinia).ensureAuthChecked();
app.use(MotionPlugin);
installUnsavedDialogBeforeUnloadGuard();

app.mount('#app');
